import {
  ClosePageWrapper,
  LeftPart,
} from "@/pages/authorization-management/views/auth-close-page/atom";
import { Button, Drawer } from "@renderbus/ui";
import AuthProfileImage from "@/assets/icons/auth/auth-profile";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { ChildIntegrationSetting } from "../child-integration-setting";
import { useDingTalkSubAccountStore } from "../../store/dingtalk-subaccount-store";
import styled from "styled-components";

export function ChildManageInitPage() {
  const t = getTranslateNsT("childManager");
  const { openSettingModal, setOpenSettingModal } =
    useDingTalkSubAccountStore();

  return (
    <ChildManageInitPageWrapper>
      <ChildManageLeftPart>
        <div className="title">{t("dingtalk_subaccount_create_title")}</div>
        <div className="subtitle">
          {t("dingtalk_subaccount_create_helptext1")}
        </div>
        <ChildManageLink
          href="https://www.renderbus.com/support-new/grzx/ddzzhgl/"
          target="_blank"
        >
          {t("dingtalk_subaccount_create_helptext2")}
        </ChildManageLink>
        <Button type="primary" onClick={() => setOpenSettingModal(true)}>
          {t("dingtalk_subaccount_create_btn")}
        </Button>
      </ChildManageLeftPart>
      <ChildManageRightPart>
        <AuthProfileImage />
      </ChildManageRightPart>
      <Drawer
        width={998}
        open={openSettingModal}
        title={t("dingtalk_subaccount_integration_settings")}
        onClose={() => setOpenSettingModal(false)}
        drawerContent={<ChildIntegrationSetting />}
      />
    </ChildManageInitPageWrapper>
  );
}

const ChildManageInitPageWrapper = styled(ClosePageWrapper)`
  padding: 0;
  align-items: center;
  justify-content: center;
  border: 0;
`;
const ChildManageLink = styled.a`
  color: var(--main-color);
  margin-bottom: 70px;
  &:hover {
    color: var(--main-color);
  }
`;
const ChildManageLeftPart = styled(LeftPart)`
  display: flex;
  flex-direction: column;
  .subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 12px;
  }
`;
const ChildManageRightPart = styled.div`
  margin-left: 28px;
`;
